<template>
<div class="row" v-loading="loading">
  <div class="col-md-12">
    <card :title="title" v-if="modelSchema">
      <fg-input :error="errorMessages.id" :max-length="modelSchema.id.maxLength"
                :required="modelSchema.id.required" v-model="model.id"
                readonly
                :label="'Server number' | translate"/>

      <fg-input :error="errorMessages.description" :max-length="modelSchema.description.maxLength"
                :required="modelSchema.description.required" v-model="model.description"
                :placeholder="'Outbound server - 255' | translate" :label="'Name' | translate"/>

      <fg-input :error="errorMessages.host" :max-length="modelSchema.host.maxLength"
                :required="modelSchema.host.required" v-model="model.host"
                placeholder="https://xxx.rcsrv.ru" :label="'Server address' | translate"/>

      <fg-input :error="errorMessages.crc" :max-length="modelSchema.crc.maxLength"
                :required="modelSchema.crc.required" v-model="model.crc"
                placeholder="00ABCDEF" :label="'Old ExpoStat Server ID' | translate"/>

      <fg-input :error="errorMessages.uuid" :max-length="modelSchema.uuid.maxLength"
                :required="modelSchema.uuid.required" v-model="model.uuid"
                placeholder="0123456789abcdef0123456789abcdef" :label="'ExpoStat Server UUID' | translate"/>

      <p-button type="info" round @click="save">
        <translate key="add" v-if="!isNew">Save</translate>
        <translate key="save" v-else>Add</translate>
      </p-button>
      <p-button type="info" round @click="saveAndClose">
        <translate key="add" v-if="!isNew">Save and close</translate>
        <translate key="save" v-else>Add and close</translate>
      </p-button>

    </card> <!-- end card -->
  </div> <!--  end col-md-6  -->
</div>
</template>

<script>
  import _ from 'lodash'
  import {Card} from 'src/components/UIComponents'

  export default {
    breadcrumb () {
      return {
        label: this.title,
        parent: {
          name: 'manage-servers',
          label: this.$gettext('Servers')
        }
      }
    },
    components: {
      Card
    },
    props: {
      baseApi: {
        type: String,
        description: 'Remote API base URL',
        default: () => 'expostat/server/'
      }
    },
    name: 'ServerForm',
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.id) {
          vm.loadRecord(to.params.id)
        }
      })
    },
    computed: {
      title () {
        if (this.isNew) {
          return this.$gettext('Add server')
        } else {
          return this.$gettext('Edit server')
        }
      },
      isNew () {
        return this.model.id === null
      },
    },
    created () {
      this.getSchema()

    },
    mounted () {
      if (this.$route.params.id && !this.model.id) {
        this.loadRecord(this.$route.params.id)
      }
    },
    data () {
      return {
        loading: false,
        errorMessages: {},
        modelSchema: null,
        model: {
          id: null,
          description: null,
          crc: null,
          host: null,
          uuid: null,
        }
      }
    },
    methods: {
      updateModel (model) {
        this.model = model
      },
      prepareModelToSave() {
        return _.cloneDeep(this.model)
      },
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.$props.baseApi}${id}/`)
        this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async getSchema () {
        let url = this.$props.baseApi
        const result = await this.$http.options(url)
        this.schema = result.data
        this.modelSchema = this.schema.actions.POST
      },
      async save () {
        this.loading = true
        const modelToSave = this.prepareModelToSave()
        const request = this.isNew ? this.$http.post(this.$props.baseApi, modelToSave) : this.$http.put(`${this.$props.baseApi}${this.model.id}/`, modelToSave)
        try {
          const result = await request
          this.updateModel(result.data)
          this.loading = false
          this.errorMessages = {}
          return true
        } catch (error) {
          this.loading = false
          this.errorMessages = _.mapValues(error.response.data, x => x instanceof Array ? x.join(', ') : x)
          return false
        }
      },
      async saveAndClose () {
        if (await this.save()) {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style scoped>

</style>
